import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import user from './modules/user'
import skill from './modules/skill'
import activity from './modules/activity'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    skill,
    activity
  },
  getters,
})

export default store
